package gr.tech.pdfgenerator.models

import gr.tech.pdfgenerator.util.AvgRate
import gr.tech.pdfgenerator.util.formatCurrency
import kotlinx.serialization.Serializable

@Serializable
data class ProposalInputsDTO(
//    var baselineKWH: Long = 5033523,
//    var baselineFixCount: Long = 818,
//    var proposedKWH: Long = 2856158,
//    var proposedFixCount: Long = 673,
//    var projectCost: Long = 50000000,             //Storing in Cents. Divide by 100.00 for Dollars.
//    var rebate: Long = 19953800,                  //Use formatCurrency() to get String with USD.
    var baselineKWH: Long = 0,
    var baselineFixCount: Long = 0,
    var proposedKWH: Long = 0,
    var proposedFixCount: Long = 0,
    var projectCost: Long = 0,             //Storing in Cents. Divide by 100.00 for Dollars.
    var rebate: Long = 0,
    var selectedState: AvgRate? = AvgRate(),
    var selectedStateElectricityRate: Double = 0.0,
    var optionalElectricityRate: Double = 0.0,

    /* Assumptions */
    var utilityRateInflation: Double = 0.0,
    var hvacInteractionSavings: Double = 0.0,
    var hvacUpTime: Double = 0.0,
    var hpsMaintenance: Long = 0,

    /* finance & leasing toggle */
    var toggleFinancePage: Boolean = false,
    var toggleLeasingPage: Boolean = false,
) {
    override fun toString(): String {
        return """
            |ProposalInputsDTO(
            |  Baseline kWh                      : $baselineKWH
            |  Baseline Fixture Count            : $baselineFixCount
            |  Proposed kWh                      : $proposedKWH
            |  Proposed Fixture Count            : $proposedFixCount
            |  Project Cost                      : ${formatCurrency(projectCost)}
            |  Rebate                            : ${formatCurrency(rebate)}
            |  Selected State                    : ${selectedState ?: "None"}
            |  State Electricity Rate ($/kWh)    : $selectedStateElectricityRate
            |  Optional Electricity Rate ($/kWh) : $optionalElectricityRate
            |  
            |  Assumptions:
            |  - Utility Rate Inflation (%)      : $utilityRateInflation
            |  - HVAC Interaction Savings (%)    : $hvacInteractionSavings
            |  - HVAC Up-Time (%)                : $hvacUpTime
            |  - HPS Maintenance Cost            : ${formatCurrency(hpsMaintenance)}
            |)
        """.trimMargin()
    }
}